
import Highcharts from "highcharts";
import map from "highcharts/modules/map";
map(Highcharts);


export default (node, config) => {

    const redraw = true;
    const oneToOne = true;

    let chartConfig = config['config'];

    const chart = Highcharts.mapChart(node, chartConfig);

    return {
        update(config) {

            if (chartConfig !== config['config']) {

                chartConfig = config['config'];
                chart.update(chartConfig, redraw, oneToOne);

            }

            if (config['zoom'] === 'zoomin') {

                chart.mapZoom(0.5);

            } else if (config['zoom'] === 'zoomout') {

                chart.mapZoom(2);

            }

        },
        destroy() {

            chart.destroy();
        }
    };
}